<div class="listing-details-wrapper">
  <div class="details-container">
    <h1 class="publisher-title">{{ toTitleCase(selListing.publisher) }}</h1>
      
    <div class="details-header">
      <h2>RenderSEO Listing Details</h2>
    </div>

    <div class="details" *ngIf="selListing; else noListing">
      <p><span appHighlightText>Business name: </span>{{ selListing.business_name }}</p>
      <p><span appHighlightText>Address: </span>{{ selListing.address }}</p>
      <p><span appHighlightText>City: </span>{{ selListing.city }}</p>
      <p><span appHighlightText>State: </span>{{ selListing.state }}</p>
      <p><span appHighlightText>Postal code: </span>{{ selListing.postal_code }}</p>
      <p><span appHighlightText>Store code: </span>{{ selListing.store_code }}</p>
      <p *ngIf="selListing.phone_numbers?.length">
        <span appHighlightText>Phone number: </span>{{ selListing.phone_numbers[0] }}
      </p>
    </div>

    <ng-template #noListing>
      <div class="no_details">
        <p>Error displaying your selected listing. Please go back and select the listing again.</p>
      </div>
    </ng-template>
  </div>
  <hr class="divider" />
  <div class="matches-container">
    <div class="matches-header">
      <h2>{{ toTitleCase(selListing.publisher) }} Matches</h2>
    </div>

    <div class="matches" *ngIf="listingMatches && listingMatches.length > 0 || isLoadingData; else noMatches">
      <p-progressSpinner class="spinner" *ngIf="isLoadingData" styleClass="w-2rem h-2rem" strokeWidth="2"
        fill="var(--surface-ground)" animationDuration="spinnerAnimationDuration">
      </p-progressSpinner>
      <p-accordion [multiple]="false">
        <p-accordionTab *ngFor="let match of listingMatches">
          <ng-template pTemplate="header">
            <div
              class="accordion-header"
              [ngClass]="{ 'selected-match': match.match_status === 'selected' }"
              style="display: flex; align-items: center; gap: 0.5rem;"
            >
              <input
                type="radio"
                name="selMatch"
                [value]="match"
                [(ngModel)]="selMatch"
                (click)="$event.stopPropagation()"
              />
              <span>{{ match.business_name }}</span>
              <span *ngIf="match.match_status === 'selected'" class="badge"><i class="pi pi-check-circle" style="margin-right: 4px;"></i> Selected</span>
            </div>
          </ng-template>
          <div class="match-details">
            <p><strong>Address:</strong> {{ getJoinedAddress(match.address) }}</p>
            <p><strong>City:</strong> {{ match.city }}</p>
            <p><strong>State:</strong> {{ match.state }}</p>
            <p><strong>Postal Code:</strong> {{ match.postal_code }}</p>
            <p><strong>Phone:</strong> {{ match.phone_number }}</p>
            <p><strong>Status:</strong> {{ match.status }}</p>
            <p><strong>Match Status:</strong> {{ match.match_status }}</p>
          </div>
        </p-accordionTab>
      </p-accordion>
      </div>
    <ng-template #noMatches>
      <div class="no_matches">
        <p>No matches found for this listing.</p>
      </div>
    </ng-template>
    <div class="match-actions" style="display: flex; justify-content: center; margin-top: 1rem; gap: 1rem;">
      <button pButton label="Generate Matches" (click)="generateMatches()" [disabled]="!selListing || isLoadingData"></button>
      <button pButton label="Save Selection" (click)="saveSelection()" [disabled]="!selMatch || isLoadingData"></button>
      <button pButton label="No Match: Create Listing" (click)="createListing()" [disabled]="isLoadingData"></button>
    </div>
  </div>
